const TICKERS_TO_NO_INDEX = [
    'cook',
    'michtemp',
    'rainhou',
    'peso',
    'evmkt',
    'indoorsf',
    'vaxxomni',
    'lanarey',
    'fxeuro',
    'vanratewc',
    'caoy',
    'gnsour',
    'casem',
    'booster',
    'cased',
    'vanratese',
    'casew',
    'bedoya',
    'schlsf',
    'casesurge',
    'conrova',
    'onrrp',
    'lizarraga',
    'taper',
    'vaxxkid',
    'covidbill',
    'happier',
    'varba2',
    'donda',
    'case7dny',
    'case7d',
    'caselow',
    'casewfr',
    'kanye',
    'monkeypox',
    'rainno',
    'cngdp',
    'carbontax',
    'case7dnyc',
    'casewcn',
    'case7da',
    'jefferson',
    'fedconf',
    'hurcland',
    'reclaw',
    'covpill',
    'casewde',
    'childs',
    'dinenyc',
    'schlnyc',
    'loverboy',
    'ftaper',
    'vardelta',
    'hurcath',
    'vaxx',
    'case7dca',
    'ambcn',
    'case7dcn',
    'tsa',
    'brainard',
    'dinenycs',
    'orddly',
    'trddefcn',
    'pmla',
    'newflu',
    'case7dtx',
    'case7dfl',
    'casewit',
    'fluv',
    'forb',
    'ctcs',
    'covvhc',
    'evict',
    'kxloper',
    'kxboeing737max9',
    'kxmurthymissouri',
    'kxmessiah',
    'kxsffa',
    'kxdrivers',
    'kxyinvert',
    'kxrthotds2',
    'kxpleavelaw',
    'kxopenaisuit',
    'kxmcstellarblade',
    'kxwga',
    'kxvisionpro',
    'kxeclipsecover',
    'kxvoncuk',
    'kxngasmin',
    'kxvanratemw',
    'kxgrantspass',
    'kxsdebt',
    'kxrtsympath',
    'kxvanratene',
    'kxseaice',
    'kxrtfirstomen',
    'kxlcpimin',
    'kxtravelwarn',
    'kxmaskmand',
    'kxnepa',
    'kxsotw',
    'kxdiesel',
    'kxcarvmak',
    'kxmead',
    'kxrtacolyte',
    'kxrtghostbusterfe',
    'kxfednom',
    'kxuawlength',
    'kxrecnc',
    'kxinfralw',
    'kxdaylight',
    'kxrtcivil',
    'kxmichigancoach',
    'kxportla',
    'kxtechreg',
    'kxboard',
    'kxu3min',
    'kxuaw',
    'kxolymcancel',
    'kxsag',
    'kxvaxmand',
    'kxmetacriticerdtree',
    'kxmooreus',
    'kxsaltx',
    'kxsohn',
    'kxtiktoksell',
    'kxinfra',
    'kxemmycacto',
    'kxolymed',
    'kxapplewatch',
    'kxrecnch',
    'kxgpt4p5',
    'kxopenaiboardj',
    'kxgptparam',
    'kxprek',
    'kxemmydactr',
    'kxmta',
    'kxvanrate',
    'kxdonda2',
    'kxvanratesc',
    'kxneuralink',
    'kxrrf',
    'kxavatarseason2',
    'kxrtabigail',
    'kxppunish',
    'kxoilw',
    'kxcorptax',
    'kxfdacaliff',
    'kxmchellblade2',
    'kxvaromic',
    'kxrtgodzillaxkong',
    'kxngas',
    'kxlifeexp',
    'kxrtkinds',
    'kxbillboardpeakchihiro',
    'kxrtfallout',
    'kxbillboardpeaknlg',
    'kxtopsongrecordppp',
    'kxrtmegalopolis',
    'kx1songbillieeilish',
    'kxrtinsideout2',
    'kxrtchallengers',
    'kxrtdespicableme4',
    'kxbillboardpeakhoudini',
    'kxdebate',
    'kx1songmacklemore',
    'kxrtfuriosa',
    'kxjbeardbnr',
    'kxdebatehappen',
    'kxbillboardpeakppp',
    'kxmcdawntrail',
    'kxrtwatchers',
    'kxtopsongrecord',
    'kxrtapes',
    'kxrtthebear',
    'kxlbjr',
    'kxrtif',
    'kxjbeardort',
    'kxrtezra',
    'kxrtquietplacedayone',
    'kxrtthefallguy',
    'kxtopsongrecordihsh',
    'kxbillboardpeak-e',
    'kxrtblinktwice',
    'kxrtbeetlejuice',
    'kxrtreagan',
    'kxbillboardpeaktaste',
    'kxmcmetaphor',
    'kxrtspeaknoevil',
    'kxrtagathaallalong',
    'kxhome',
    'kxmcblackops6',
    'kxmcsilenthill2',
    'kxrtchristmaspageant',
    'kxrtsmile2',
    'kxrtterrifier3',
    'kxrtvenom3',
    'kxrtwildrobot',
    'kxcook',
    'kxmichtemp',
    'kxrainhou',
    'kxpeso',
    'kxevmkt',
    'kxindoorsf',
    'kxvaxxomni',
    'kxlanarey',
    'kxfxeuro',
    'kxvanratewc',
    'kxcaoy',
    'kxgnsour',
    'kxcasem',
    'kxbooster',
    'kxcased',
    'kxvanratese',
    'kxcasew',
    'kxbedoya',
    'kxschlsf',
    'kxcasesurge',
    'kxconrova',
    'kxonrrp',
    'kxlizarraga',
    'kxtaper',
    'kxvaxxkid',
    'kxcovidbill',
    'kxhappier',
    'kxvarba2',
    'kxdonda',
    'kxcase7dny',
    'kxcase7d',
    'kxcaselow',
    'kxcasewfr',
    'kxkanye',
    'kxmonkeypox',
    'kxrainno',
    'kxcngdp',
    'kxcarbontax',
    'kxcase7dnyc',
    'kxcasewcn',
    'kxcase7da',
    'kxjefferson',
    'kxfedconf',
    'kxhurcland',
    'kxreclaw',
    'kxcovpill',
    'kxcasewde',
    'kxchilds',
    'kxdinenyc',
    'kxschlnyc',
    'kxloverboy',
    'kxftaper',
    'kxvardelta',
    'kxhurcath',
    'kxvaxx',
    'kxcase7dca',
    'kxambcn',
    'kxcase7dcn',
    'kxtsa',
    'kxbrainard',
    'kxdinenycs',
    'kxdorddly',
    'kxtrddefcn',
    'kxpmla',
    'kxnewflu',
    'kxcase7dtx',
    'kxcase7dfl',
    'kxcasewit',
    'kxfluv',
    'kxforb',
    'kxctcs',
    'kxcovvhc',
    'kxevict',
];

export const isIndexSeries = (seriesTicker?: string): boolean =>
    !!seriesTicker &&
    (seriesTicker.startsWith('INX') ||
        seriesTicker.startsWith('NASDAQ') ||
        seriesTicker.startsWith('KXINX') ||
        seriesTicker.startsWith('KXNASDAQ'));

export const isCostcoSeries = (seriesTicker?: string): boolean =>
    (!!seriesTicker && seriesTicker === 'KXCOSTCOHOTDOG') || seriesTicker === 'KXCOSTCOMEMBER';

export const isDeterminedSeriesToNoIndex = (seriesTicker: string): boolean => {
    if (seriesTicker) {
        const lowercaseTicker = seriesTicker.toLowerCase();
        const shouldNoIndex = TICKERS_TO_NO_INDEX.includes(lowercaseTicker);
        return shouldNoIndex;
    }

    return false;
};

export const isNbaProp = (seriesTicker?: string): boolean => {
    if (!seriesTicker) return false;
    return ['KXNBAPTS', 'KXNBAAST', 'KXNBAREB', 'KXNBASTL', 'KXNBABLK', 'KXNBA3PT', 'KXNBA2D', 'KXNBA3D'].includes(
        seriesTicker,
    );
};
